const DAILY_HOW_TO_DISMISSED_KEY = 'zi:daily-how-to-dismissed:v1';

function canUseLocalStorage() {
  try {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  } catch {
    return false;
  }
}

/**
 * @returns {boolean|null} boolean when saved, otherwise null
 */
export function loadDailyHowToDismissedPreference() {
  if (!canUseLocalStorage()) return null;

  try {
    const raw = window.localStorage.getItem(DAILY_HOW_TO_DISMISSED_KEY);
    if (raw === null) return null;
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    return null;
  } catch {
    return null;
  }
}

/**
 * @param {boolean} value
 */
export function saveDailyHowToDismissedPreference(value) {
  if (!canUseLocalStorage()) return;

  try {
    window.localStorage.setItem(DAILY_HOW_TO_DISMISSED_KEY, String(Boolean(value)));
  } catch {
    // ignore write failures (private mode, quota, etc.)
  }
}
